export const staticColumnsModel: string[] = [
  'speeds',
  'in_torques',
  'out_torques',
  'in_powers',
  'out_powers',
  'efficiencies',
  'losses',
  'gear_ratios',
  'temperatures_rotor',
  'temperatures_stator_winding',
  'temperatures_stator_winding_peak',
];
